<template>

    <div class="credit-balance-card" v-loading="loading">
        <el-card shadow="hover">

            <!-- Header -->
            <div class="header">
                <span class="title">SMS Credit Balance</span>
                <el-tag type="success" effect="dark">Semaphore</el-tag>
            </div>

            <!-- Balance -->
            <div class="balance">
                <span :class="['amount', balanceClass]">{{ formattedBalance }}</span>
                <span class="unit">credits</span>
            </div>

            <!-- Info -->
            <el-alert effect="dark" :closable="false" :type="alertType" class="alert">
                {{ alertMessage }}
            </el-alert>



        </el-card>
    </div>
</template>

<script>
import { Client } from '@/resources/client'

export default {
    data() {
        return {
            credit_balance: 0,
            loading: false
        }
    },

    computed: {
        formattedBalance() {
            const value = Math.round(this.credit_balance * 100) / 100
            return value.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        },
        balanceClass() {
            if (this.credit_balance <= 500) return 'danger'
            if (this.credit_balance <= 1000) return 'warning'
            return 'normal'
        },

        alertType() {
            if (this.credit_balance <= 500) return 'error'
            if (this.credit_balance <= 1000) return 'warning'
            return 'success'
        },

        alertMessage() {
            if (this.credit_balance <= 500) {
                return 'Low balance! Immediate reload required.'
            }
            if (this.credit_balance <= 1000) {
                return 'Low balance. Please reload soon.'
            }
            return 'Credit balance is refreshed every 2 minutes.'
        }
    },

    created() {
        this.fetchBalance()
    },
    methods: {
        async fetchBalance() {
            this.loading = true

            Client.show('WEESAM')
                .then(result => {
                    this.credit_balance = result.data.client.sms_credit_balance || 0
                })
                .catch(() => {
                    this.$notify({
                        type: 'danger',
                        title: "Error",
                        text: 'Unable to fetch balance at the moment',
                    });

                }).finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style scoped>
.credit-balance-card {
    max-width: 100%;
    margin-bottom: 10px;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.title {
    font-weight: 600;
    font-size: 16px;
}

.balance {
    text-align: center;
    margin: 20px 0;
}

.amount {
    font-size: 36px;
    font-weight: bold;
    color: #409EFF;
}

.unit {
    margin-left: 5px;
    color: #999;
}

.alert {
    margin-bottom: 15px;
}

.actions {
    text-align: right;
}

.amount.normal {
    color: #409EFF;
    /* blue */
}

.amount.warning {
    color: #E6A23C;
    /* yellow */
}

.amount.danger {
    color: #F56C6C;
    /* red */
}
</style>